import { TaskDto } from '@maia/shared';
import { ReactNode } from 'react';
import { OpenTaskWidget } from './open-task-widget';
import { useDrawerStore } from './../../../stores/drawer.store';

type TaskListProps = {
  filterSlot?: ReactNode;
  tasks: Array<TaskDto>;
};

export function TaskList(props: TaskListProps) {
  const { openDrawer } = useDrawerStore();
  const { filterSlot, tasks } = props;

  return (
    <div className="flex flex-col gap-y-24 w-full">
      {filterSlot}
      <ul className="flex flex-col gap-y-12 w-full">
        {tasks.map((task) => (
          <li id={task.guid}>
            <OpenTaskWidget
              task={task}
              onOpen={() => openDrawer({ type: 'task', data: task })}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
